

const state = () => ({
    path: [],
})

export default state